// extracted by extract-css-chunks-webpack-plugin
module.exports = {"gnipp":"financial-data__gnipp--2TmJv","prfDisc":"financial-data__prfDisc--1xo96"};